import { ChevronDown } from 'lucide-react';
import type { ScoreSummary } from '../types';
import { ScoreBadge } from './status';

export function EvaluatorResults({ score }: { score: ScoreSummary | null }) {
  if (!score) {
    return (
      <div className="rounded-md border border-border/80 bg-muted/20 px-3 py-3 text-sm text-muted-foreground">
        No evaluator scores are available for this conversation yet.
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-medium text-foreground">Average</p>
        <ScoreBadge score={score.average} prefix="" />
      </div>
      <div className="divide-y rounded-md border border-border/80">
        {score.details.map((detail) => (
          <details key={detail.key} className="group px-3 py-2">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-3">
              <span className="min-w-0 truncate text-sm text-foreground">{detail.label}</span>
              <span className="flex shrink-0 items-center gap-2">
                <ScoreBadge score={detail.score} prefix="" />
                <ChevronDown className="h-3.5 w-3.5 text-muted-foreground transition-transform group-open:rotate-180" />
              </span>
            </summary>
            {detail.reasoning ? (
              <p className="mt-2 text-sm leading-5 text-muted-foreground">{detail.reasoning}</p>
            ) : (
              <p className="mt-2 text-sm text-muted-foreground">No additional notes.</p>
            )}
          </details>
        ))}
      </div>
    </div>
  );
}
